import {
  ShieldCheck,
  Scale,
  Settings2,
  Rocket,
  Headphones,
  Sparkles,
} from "lucide-react";

const REASONS = [
  {
    icon: ShieldCheck,
    title: "Segurança da Informação",
    desc: "Criptografia, controle de acesso e boas práticas de cibersegurança em saúde.",
  },
  {
    icon: Scale,
    title: "Conformidade com LGPD",
    desc: "Governança de dados sensíveis e aderência total à Lei Geral de Proteção de Dados.",
  },
  {
    icon: Settings2,
    title: "Soluções Personalizadas",
    desc: "Nada de solução engessada. Modelamos a tecnologia à sua operação.",
  },
  {
    icon: Rocket,
    title: "Implantação Rápida",
    desc: "Metodologia ágil e entregas incrementais com go-live acelerado.",
  },
  {
    icon: Headphones,
    title: "Suporte Especializado",
    desc: "Time consultivo dedicado, com SLA para ambientes críticos 24/7.",
  },
  {
    icon: Sparkles,
    title: "Tecnologia Moderna",
    desc: "Cloud-native, APIs abertas e IA aplicada ao contexto hospitalar.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-section"
      className="relative bg-[#0B1220] text-white overflow-hidden py-24 lg:py-32"
    >
      <div className="grain absolute inset-0" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          <div className="lg:col-span-6">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-[#3B82F6] mb-4">
              /03 · Por que a Áxis
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-semibold leading-[1.05]">
              Por que escolher a{" "}
              <span className="text-white">Áxis Saúde Digital?</span>
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-base md:text-lg text-gray-400 leading-relaxed">
              Somos especialistas em ambientes hospitalares. Entendemos rotinas
              assistenciais, indicadores gerenciais e a exigência de sistemas
              críticos que não podem falhar.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-800">
          {REASONS.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              data-testid={`why-card-${i}`}
              className="bg-[#0B1220] p-8 lg:p-10 hover:bg-[#111827] transition-colors group"
            >
              <div className="flex items-center gap-3 mb-6">
                <Icon
                  className="w-6 h-6 text-[#1E3A8A] group-hover:scale-110 transition-transform"
                  strokeWidth={1.75}
                />
                <span className="font-mono-axis text-xs text-gray-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-xl font-medium tracking-tight text-white">
                {title}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
